import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './api/overrideAlert';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('YOUR_SYNCFUSION_LICENSE_KEY_HERE');

// ─────────────────────────────────────────────────────────────────────────────
// 🔐 RESET PASSWORD LINK HANDLER
// Runs before React mounts.
// When user clicks the email link:
//   http://yourapp.com/reset-password?email=foo@bar.com&token=CfDJ8...
// This block reads those params, saves them to sessionStorage,
// then lets App.js know to show the ForgotPasswordPage (step 2).
// ─────────────────────────────────────────────────────────────────────────────
const path = window.location.pathname;

if (path === '/reset-password' || path.includes('reset-password')) {
  const params = new URLSearchParams(window.location.search);
  const token  = params.get('token');
  const email  = params.get('email');

  if (token) {
    sessionStorage.setItem('resetToken',  token);
    sessionStorage.setItem('isResetLink', 'true');
    // console.log('🔐 Reset token captured from URL');
  }
  if (email) {
    sessionStorage.setItem('resetEmail', email);
    // console.log('📧 Reset email captured from URL:', email);
  }

  // Clean up the URL so the token isn't visible in the address bar
  // and replace the path with your app's base path
  window.history.replaceState({}, document.title, '/');
}
// ─────────────────────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();